import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { NormativePanel, SegmentedControl } from '../../NormativeModeling';
import { AbnormalitiesPanel } from './AbnormalitiesPanel';
import LocalPatientUpload from '../../LocalPatientUpload';

// Panels the user can switch between. Normative Modeling stays hidden for now,
// so it is intentionally omitted here even though the view still renders when set.
const PANEL_SWITCHER_OPTIONS = [
    { value: 'abnormalities', label: 'Normative Model' },
    { value: 'upload', label: 'Upload Patient' }
];


// -------------------------------
// Subcomponent: ControlPanel
// Contains all data input controls and visualization settings
// -------------------------------
export const ControlPanel = ({
    viewer,
    selectedFormat,
    setSelectedFormat,
    selectedBackground,
    setSelectedBackground,
    selectedCenters,
    selectedPatients,
    onCenterToggle,
    onPatientToggle,
    centers,
    patients,
    centersLoading,
    centersError,
    patientsLoading,
    patientsError,
    isPanelCollapsed,
    setIsPanelCollapsed,
    isLargeScreen,
    panelView,
    setPanelView,
    patientDataApi,
    setHasIntensityData,
    setCurrentObjectFilename,
    settingsState,
    setSettingsState,
    brainOpacity,
    wireframeEnabled,
    setWireframeEnabled,
    applyOpacityToScene,
    applyWireframeState,
    brainCaptureApi,
    onDeselectAllPatients,
    onLocalPatientsLoaded,
    montageType,
    loading
}) => {
    const togglePanelCollapse = () => {
        setIsPanelCollapsed(!isPanelCollapsed);
    };

    return (
        <div className={`control-panel ${isLargeScreen && isPanelCollapsed ? 'collapsed' : ''}`}>
            <button
                className="collapse-button"
                onClick={togglePanelCollapse}
                title={isPanelCollapsed ? "Expand panel" : "Collapse panel"}
            >
                {isPanelCollapsed ? <PanelLeftOpen size={16} /> : <PanelLeftClose size={16} />}
            </button>

            <div className="panel-title-dropdown">
                <div className="panel-title" style={{ cursor: 'default' }}>
                    <h2>IEEG Abnormalities</h2>
                </div>
            </div>

            {panelView !== 'normative' && (
                <div className="panel-switcher">
                    <SegmentedControl
                        name="Panel view"
                        options={PANEL_SWITCHER_OPTIONS}
                        selectedValue={panelView === 'upload' ? 'upload' : 'abnormalities'}
                        onChange={setPanelView}
                    />
                </div>
            )}

            {panelView === 'normative' && <NormativePanel patientDataApi={patientDataApi} />}
            {panelView === 'upload' && (
                <LocalPatientUpload
                    montageType={montageType}
                    onLocalPatientsLoaded={onLocalPatientsLoaded}
                />
            )}
            {panelView === 'abnormalities' && (
                <AbnormalitiesPanel
                    selectedCenters={selectedCenters}
                    selectedPatients={selectedPatients}
                    onCenterToggle={onCenterToggle}
                    onPatientToggle={onPatientToggle}
                    centers={centers}
                    patients={patients}
                    centersLoading={centersLoading}
                    centersError={centersError}
                    patientsLoading={patientsLoading}
                    patientsError={patientsError}
                    loading={loading}
                    patientDataApi={patientDataApi}
                    brainCaptureApi={brainCaptureApi}
                    onDeselectAllPatients={onDeselectAllPatients}
                />
            )}
        </div>
    );
};


// -------------------------------
// Core Functionality
// -------------------------------
